import '../data/store';
import '../../scss/tailwind.scss';
import { __ } from '@wordpress/i18n';
import domReady from '@wordpress/dom-ready';
import QuoteList from './Components/QuoteList';
import QuoteDetails from './Components/QuoteDetails';

domReady( () => {
    // @ts-ignore
    window.wp.hooks.addFilter(
        'dokan-dashboard-routes',
        'dokan-request-for-quote-list',
        function ( routes ) {
            routes.push( {
                id: 'dokan-request-for-quote-list',
                path: 'requested-quotes',
                title: __( 'Request for Quotation', 'dokan' ),
                exact: true,
                order: 53,
                parent: '',
                element: QuoteList,
                capabilities: [ 'dokan_view_request_quote_menu' ],
            } );

            return routes;
        }
    );

    // @ts-ignore
    window.wp.hooks.addFilter(
        'dokan-dashboard-routes',
        'dokan-request-for-quote-details',
        function ( routes ) {
            routes.push( {
                id: 'dokan-request-for-quote-details',
                path: 'requested-quotes/:quoteId',
                exact: true,
                order: 53,
                title: __( 'Request Quotes', 'dokan' ),
                parent: '',
                backUrl: '/requested-quotes',
                element: QuoteDetails,
                capabilities: [ 'dokan_view_request_quote_menu' ],
            } );

            return routes;
        }
    );
} );
